import { GeneralAttachedFilePost, GeneralAttachedFile, GeneralAttachedFileApiFactory } from '@/api'
import { BaseUserActionRequest } from '@/requests/baseRequest'
import { AxiosPromise } from 'axios'
/**
 * 汎用添付ファイルテーブル更新処理
 */
export class CreateGeneralAttachedFileApiRequest extends BaseUserActionRequest {
  private GeneralAttachedFilePost: GeneralAttachedFilePost

  constructor(GeneralAttachedFilePost: GeneralAttachedFilePost) {
    super()
    this.GeneralAttachedFilePost = GeneralAttachedFilePost
  }

  protected request(): AxiosPromise<GeneralAttachedFile> {
    const api = GeneralAttachedFileApiFactory()
    return api.generalAttachedFileCreate(this.GeneralAttachedFilePost)
  }
}

/**
 * 汎用添付ファイルテーブル削除処理
 */
export class DeleteGeneralAttachedFileApiRequest extends BaseUserActionRequest {
  private GeneralAttachedFile: GeneralAttachedFile

  constructor(GeneralAttachedFile: GeneralAttachedFile) {
    super()
    this.GeneralAttachedFile = GeneralAttachedFile
  }

  protected request(): AxiosPromise<GeneralAttachedFile> {
    const api = GeneralAttachedFileApiFactory()
    return api.generalAttachedFileDelete(this.GeneralAttachedFile)
  }
}
